import { FunctionComponent } from 'react';
import { InvoicesHeaderRow, InvoicesHeaderCell } from './styled';

const InvoicesTableHeaderRow: FunctionComponent = () => (
    <InvoicesHeaderRow>
        <InvoicesHeaderCell>Status</InvoicesHeaderCell>
        <InvoicesHeaderCell>Amount</InvoicesHeaderCell>
        <InvoicesHeaderCell>Billing Reason</InvoicesHeaderCell>
        <InvoicesHeaderCell>Period</InvoicesHeaderCell>
        <InvoicesHeaderCell>Due Date</InvoicesHeaderCell>
        <InvoicesHeaderCell>Paid At</InvoicesHeaderCell>
        <InvoicesHeaderCell>Actions</InvoicesHeaderCell>
    </InvoicesHeaderRow>
);

export default InvoicesTableHeaderRow;
